<template>
  <div id="container" class="index" ref="container" v-cloak>
    <van-sticky>
      <div class="header acea-row row-center-wrapper">
        <van-skeleton avatar :loading="top_loading">
          <div class="logo"><img :src="logoUrl" /></div>
        </van-skeleton>
        <router-link :to="'/search'" class="search acea-row row-middle">
          <span class="iconfont icon-xiazai5"></span>搜索商品
        </router-link>
      </div>
      <div>
        <!--banner-->
        <div>
          <swiper :options="telOption">
            <swiper-slide>
              <div class="notice-bar" @click='callSiteServicePhone'>
                商城客服微信电话：{{ site_service_phone }}
                <span style="font-size: 0.8em;">（点击联系）</span>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="notice-bar" @click='callComplainServicePhone'>
                服务监督投诉热线：{{ complain_service_phone }}
                <span style="font-size: 0.8em;">（点击联系）</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </van-sticky>

    <div>
      <!--banner-->
      <div class="slider-banner banner" v-if="banner.length > 0 && isKeep">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in banner" :key="index">
            <router-link :to="item.wap_url ? item.wap_url : ''" class="search acea-row row-middle">
              <img :src="item.pic" />
            </router-link>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!--功能模块-->
      <div class="nav acea-row">
        <van-skeleton avatar :loading="top_loading"> </van-skeleton>
        <van-skeleton avatar :loading="top_loading"> </van-skeleton>
        <router-link :to="item.wap_url ? item.wap_url : ''" class="item" v-for="(item, index) in menus" :key="index">
          <div class="pictrue"><img :src="item.pic" /></div>
          <div>{{ item.name }}</div>
        </router-link>
      </div>
      <!--限时秒杀-->
      <div class="hotList" v-if="seckill.length > 0 && isKeep">
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label">限时秒杀</span>
            </div>
            <router-link :to="{ path: '/activity/goods_seckill' }" class="more">
              查看全部<span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
        <div class="list acea-row row-middle">
          <swiper class="activity-swiper" :options="swiperProducts">
            <router-link :to="{
                path: '/activity/goods_seckill',
                query: { type: 'seckill', id: item.id, time: item.id },
              }" class="swiper-slide brand-slide item" v-for="(item, index) in seckill" :key="index">
              <div class="pictrue">
                <img :src="item.image" />
              </div>
              <div class="name line1">{{ item.title }}</div>
              <div class="money font-color-red">
                <span v-show="item.price !== '请先登录'">￥</span>
                <span class="num">{{ item.price }}</span>
              </div>
            </router-link>
          </swiper>
        </div>
      </div>
      <!--今日特价-->
      <div class="hotList" v-if="specialoffer.length > 0 && isKeep">
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label">今日特价</span>
            </div>
            <router-link :to="{ path: '/promotion' }" class="more">
              查看全部<span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
        <div class="list acea-row row-middle">
          <swiper class="activity-swiper" :options="swiperProducts">
            <router-link class="swiper-slide brand-slide item" :to="{
                path: '/activity/special_detail',
                query: { type: 'specialoffer', id: item.id },
              }" v-for="(item, index) in specialoffer" :key="index">
              <div class="pictrue">
                <img :src="item.image" />
              </div>
              <div class="name line1">{{ item.title }}</div>
              <div class="money font-color-red">
                <span v-show="item.price !== '请先登录'">￥</span>
                <span class="num">{{ item.price }}</span>
              </div>
            </router-link>
          </swiper>
        </div>
      </div>
      <!--打折优惠-->
      <div class="hotList" v-if="discount.length > 0">
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label">打折优惠</span>
            </div>
            <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
              查看全部<span class="iconfont icon-jiantou"></span>
            </router-link>
          </div>
        </div>
        <div class="list acea-row row-middle">
          <swiper class="activity-swiper" :options="swiperProducts">
            <router-link :to="{
                path: '/activity/discount_detail',
                query: { type: 'discount', id: item.id },
              }" class="swiper-slide brand-slide item" v-for="(item, index) in discount" :key="index">
              <div class="pictrue">
                <img :src="item.image" />
              </div>
              <div class="name line1">{{ item.title }}</div>
              <div class="money font-color-red">
                <span class="num discount">{{ item.discount }}</span>
                <span v-show="item.discount !== '请先登录'">折</span>
              </div>
            </router-link>
          </swiper>
        </div>
      </div>
      <div class="wrapper" v-if="brand.length > 0">
        <div class="title acea-row row-between-wrapper">
          <div class="text">
            <div class="name line1">
              品牌专区
            </div>
            <div class="line1">优质品牌,值得信赖</div>
          </div>
          <router-link :to="{ path: '/brand' }" class="more">查看全部<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="brand-product">
          <swiper class="swiper-wrapper brand-wrapper activity-swiper" :options="swiperProducts">
            <router-link class="swiper-slide brand-slide" v-for="(item, index) in brand" :key="index" :to="{
                path: '/goods_list',
                query: { id: item.id, title: item.name, type: 2 },
              }">
              <div class="brand-box">
                <img :src="item.logo" />
              </div>
            </router-link>
          </swiper>
        </div>
      </div>
      <div id="floor-scroll">
        <div v-for="(item, index) in floor" :key="index">
          <div class="floor wrapper">
            <div class="title acea-row row-between-wrapper">
              <div class="text">
                <div class="name line1">
                  {{ item.cate_name }}
                </div>
              </div>
              <router-link :to="{
                  path: '/goods_list',
                  query: {
                    id: item.id,
                    title: item.cate_name,
                    type: 3,
                  },
                }" class="more">查看全部<span class="iconfont icon-jiantou"></span></router-link>
            </div>
            <div class="products">
              <div :theme="1" class="list" v-for="(sub_item, index) in item.product_list.data" :key="index">
                <div class="item">
                  <router-link :to="{ path: '/detail/' + sub_item.id }">
                    <div class="img-box">
                      <img :src="sub_item.image" />
                    </div>
                    <div class="pro-info line1">
                      {{ sub_item.cate_name }}
                    </div>
                    <div class="money font-color-red">
                      <span v-show="sub_item.price !== '请先登录'">￥</span>
                      {{ sub_item.price }}
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Coupon-window :coupon-list="couponList" v-if="showCoupon" @checked="couponClose" @close="couponClose">
    </Coupon-window> -->
    <!-- <Loading :loaded="loadend" :loading="loading"></Loading> -->
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
  import Vue from "vue";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import {
    ScrollNav,
    ScrollNavPanel
  } from "vue-ydui/dist/lib.rem/scrollnav";
  import "@assets/css/swiper.min.css";
  import Recommend from "@components/Recommend";
  import CouponWindow from "@components/CouponWindow";
  import {
    getHomeData,
    getHomeBanner,
    getHomeActivity,
    getHomeBrand,
    getHomeFloor,
  } from "@api/public";
  import cookie from "@utils/store/cookie";
  import {
    Skeleton,
    Sticky,
    NoticeBar,
    Button
  } from "vant";
  import debounce from "lodash.debounce";
  import Loading from "@components/Loading";
  Vue.component(ScrollNav.name, ScrollNav);
  Vue.component(ScrollNavPanel.name, ScrollNavPanel);
  Vue.use(Skeleton)
    .use(Sticky)
    .use(NoticeBar)
    .use(Button);

  const HAS_COUPON_WINDOW = "has_coupon_window";

  export default {
    name: "Index",
    components: {
      swiper,
      swiperSlide,
      Recommend,
      CouponWindow,
      Loading,
    },
    props: {},
    data: function () {
      return {
        floor_id: '0',
        site_service_phone: "18820057778",
        complain_service_phone: "13527606002",
        loading: false,
        loadend: false,
        page: 1,
        limit: 1,
        isKeep: false,
        tabList: [],
        top_loading: true,
        class: {},
        brand: [],
        floor: [],
        floorHeight: null,
        screenHeight: null,
        hours: 1,
        minutes: 15,
        seconds: 0,
        showCoupon: false,
        logoUrl: "",
        banner: [],
        menus: [],
        roll: [],
        activity: [],
        discount: [],
        seckill: [],
        specialoffer: [],
        activityOne: {},
        info: {
          fastList: [],
          bastBanner: [],
          firstList: [],
          bastList: [],
        },
        likeInfo: [],
        lovely: {},
        benefit: [],
        couponList: [],
        history: [],
        telOption: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: true,
            delay: 3000,
          },
          loop: true,
          speed: 3000,
          observer: true,
          observeParents: true,
        },
        swiperOption: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: true,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperRoll: {
          direction: "vertical",
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperScroll: {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
        },
        swiperBoutique: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        },
        swiperProducts: {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
          speed: 1000,
          loop: true,
          autoplay: {
            disableOnInteraction: true,
            delay: 1000,
          },
        },
      };
    },
    mounted: function () {
      let that = this;
      // this.add();
      this.screenHeight = document.body.clientHeight;

      // console.log(this.screenHeight);
      getHomeBanner().then((res) => {
        that.top_loading = false;
        // console.log(res, 'banner')
        that.logoUrl = res.data.logoUrl;
        if(res.data.site_service_phone) that.site_service_phone = res.data.site_service_phone;
        if(res.data.complain_service_phone) that.complain_service_phone = res.data.complain_service_phone;
        // that.complain_service_phone = res.data.complain_service_phone;
        that.$set(that, "banner", res.data.banner_list);
        that.$set(that, "menus", res.data.menus);
        document.title = res.data.site_name;
      });
      getHomeActivity().then((res) => {
        // console.log(res, 'activity')
        that.$set(that, "specialoffer", res.data.Specialoffer);
        that.$set(that, "seckill", res.data.Seckill);
        that.$set(that, "discount", res.data.Discount);
      });
      getHomeBrand().then((res) => {
        that.$set(that, "brand", res.data);
      });
      this.getFloor();
    },
    activated() {
      this.isKeep = true;
    },
    deactivated() {
      this.isKeep = false;
    },
    created() {
      // 监听滚动事件
      // window.addEventListener('scroll', this.onScroll)
    },
    methods: {
      callSiteServicePhone() {
        window.location.href = 'tel://' + this.site_service_phone
      },
      callComplainServicePhone() {
        window.location.href = 'tel://' + this.complain_service_phone
      },
      getFloor: debounce(function (floor_id) {
        var that = this;
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        getHomeFloor({
          fids: that.floor_id,
          page: that.page,
          limit: that.limit,
        }).then((res) => {
          that.loading = false;
          // console.log(res, 'floor')
          that.floor.push.apply(that.floor, res.data);
          that.page = that.page + 1;
          if(res.data.length == 1){
            if(that.floor_id == '0'){
              console.log(res.data[0].id, 'res.data[0].id')
              that.floor_id = String(res.data[0].id)
            }else{
              that.floor_id = that.floor_id+','+String(res.data[0].id)
            }

          }
          if (res.data.length == 0) {
            that.loadend = true;
          } else {
            that.getFloor();
          }

          // let obj = {
          //   label: res.data[0].cate_name
          // }
          // that.tabList.push(obj);
        });
      }, 300),
      handleClick() {
        // console.log('handleClick');
      },
      initSwiper: function () {
        this.swiperOption = {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: true,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        };
        this.swiperRoll = {
          direction: "vertical",
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        };
        this.swiperScroll = {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
        };
        this.swiperBoutique = {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true,
        };
        this.swiperProducts = {
          freeMode: true,
          freeModeMomentum: false,
          slidesPerView: "auto",
          observer: true,
          observeParents: true,
          speed: 1000,
          loop: true,
          autoplay: {
            disableOnInteraction: true,
            delay: 1000,
          },
        };
      },
      setList(data) {
        // this.loading = false;
        var obj_1 = {
          label: "首页",
        };
        var obj_3 = {
          label: "品牌专区",
        };
        // var obj_2 = {
        //   label: '为你推荐'
        // };
        this.tabList.push(obj_1);
        this.tabList.push(obj_3);
        // if (data && data.length > 0) {
        //   data.forEach((d) => {
        //     var obj = {
        //       label: d.cate_name,
        //     };
        //     this.tabList.push(obj);
        //   });
        // }
        // this.tabList.push(obj_2);
      },
      couponClose() {
        cookie.set(HAS_COUPON_WINDOW, 1);
      },
      num: function (n) {
        return n < 10 ? "0" + n : "" + n;
      },
    },
  };
</script>

<style scoped>
  .scroll-tab {
    height: 667px;
    overflow-y: auto;
    position: relative;
  }

  .notice-bar {
    height: 0.7rem;
    line-height: 0.7rem;
    background-color: red;
    color: #fff;
    font-size: 0.3rem;
    font-weight: bold;
    text-align: center;
  }
</style>
